'use server';

import { deliverContactMessage } from './delivery';
import {
  contactSchema,
  type ContactErrorCode,
  type ContactField,
  type ContactState,
} from './schema';

export async function submitContact(
  _state: ContactState,
  formData: FormData,
): Promise<ContactState> {
  const result = contactSchema.safeParse({
    name: formData.get('name') ?? '',
    company: formData.get('company') ?? '',
    email: formData.get('email') ?? '',
    phone: formData.get('phone') ?? '',
    topic: formData.get('topic') ?? '',
    message: formData.get('message') ?? '',
    link: formData.get('link') ?? '',
    consent: formData.get('consent') === 'on',
    locale: formData.get('locale'),
  });

  if (!result.success) {
    const errors: Partial<Record<ContactField, ContactErrorCode>> = {};
    for (const issue of result.error.issues) {
      const field = issue.path[0] as ContactField;
      errors[field] ??= issue.message as ContactErrorCode;
    }
    return { status: 'invalid', errors };
  }

  try {
    await deliverContactMessage(result.data);
    return { status: 'sent' };
  } catch (error) {
    console.error('[contact] delivery failed', error);
    return { status: 'failed' };
  }
}
